export const getBrandLogoUrl = (brand, brandLogos) => {
  const brandLowerCase = brand && brand.toLowerCase()
  const brandLogo = brandLogos?.find(item => item.name.toLowerCase() === brandLowerCase)
  const brandLogoUrl = brandLogo ? brandLogo.logoUrl : null

  return brandLogoUrl
}
